<section class="flex flex-col gap-4">
  <p class="x-font-body-4 x-text-dark-secondary">
    {{ 'contractor_filter_dialog.hint' | translate }}
  </p>

  <!-- Исполнители (мульти-выбор, включая «Без исполнителя») -->
  <tui-textfield
    multi
    tuiChevron
    [stringify]="stringifyFn"
    tuiTextfieldSize="m"
    tuiDropdownLimitWidth="fixed"
    [title]="'contractor_filter_dialog.contractors_placeholder' | translate"
  >
    <label tuiLabel>{{
      'contractor_filter_dialog.contractors_placeholder' | translate
    }}</label>
    <input
      tuiInputChip
      [(ngModel)]="selectedContractors"
      (ngModelChange)="onContractorsChange()"
    />
    <tui-input-chip *tuiItem />
    <tui-data-list *tuiDropdown>
      @for (contractor of contractorOptions; track contractor.id) {
        <button tuiOption [value]="contractor" [title]="contractor.name">
          {{ contractor.name }}
        </button>
      }
    </tui-data-list>
  </tui-textfield>

  <!-- Подразделение: только при ровно одном выбранном исполнителе -->
  <tui-textfield
    tuiChevron
    [stringify]="stringifyFn"
    [tuiTextfieldCleaner]="true"
    tuiTextfieldSize="m"
    tuiDropdownLimitWidth="fixed"
    [title]="'contractor_filter_dialog.subdivision_placeholder' | translate"
  >
    <label tuiLabel>
      {{ 'contractor_filter_dialog.subdivision_placeholder' | translate }}
    </label>

    <input
      tuiSelect
      [(ngModel)]="selectedSubdivision"
      [disabled]="getSingleContractorId() === null"
    />
    <tui-data-list *tuiDropdown>
      @for (subdivision of subdivisions; track subdivision.id) {
        <button tuiOption [value]="subdivision" [title]="subdivision.name">
          {{ subdivision.name }}
        </button>
      }
    </tui-data-list>
  </tui-textfield>

  <footer class="flex gap-3 justify-end mt-2">
    <button tuiButton appearance="secondary" size="m" (click)="reset()">
      {{ 'contractor_filter_dialog.reset' | translate }}
    </button>
    <button tuiButton appearance="primary" size="m" (click)="apply()">
      {{ 'contractor_filter_dialog.apply' | translate }}
    </button>
  </footer>
</section>
